import request from '@/utils/request'

/**
 * 获取店铺列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.page_size - 每页条数
 * @param {String} params.agent_code - 店铺编码（可选）
 * @param {String} params.agent_name - 店铺名称（可选）
 * @param {Number} params.status - 状态（-1=全部，0=禁用，1=启用）
 */
export function getAgentList(params) {
 
  const requestData = {
    page: params.page || 1,
    page_size: params.page_size || 20,
    agent_code: params.agent_code?.trim() || undefined,
    agent_name: params.agent_name?.trim() || undefined,
    status: params.status !== undefined ? params.status : -1
  }
  
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/list',
    method: 'post',
    data: requestData
  })
}

/**
 * 创建店铺
 * @param {Object} data - 店铺数据
 * @param {String} data.agent_code - 店铺编码（必填，唯一）
 * @param {String} data.agent_name - 店铺名称（必填）
 * @param {String} data.contact_person - 联系人（必填）
 * @param {String} data.contact_phone - 联系电话（必填）
 * @param {String} data.contact_email - 联系邮箱（可选）
 * @param {String} data.address - 地址（可选）
 * @param {String} data.description - 描述（可选）
 * @param {Number} data.status - 状态（可选，0=禁用，1=启用，默认1）
 */
export function createAgent(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/create',
    method: 'post',
    data: {
      agent_code: data.agent_code,
      agent_name: data.agent_name,
      contact_person: data.contact_person,
      contact_phone: data.contact_phone,
      contact_email: data.contact_email || '',
      address: data.address || '',
      description: data.description || '',
      status: data.status !== undefined ? data.status : 1
    }
  })
}

/**
 * 更新店铺
 * @param {Object} data - 店铺数据
 * @param {Number} data.id - 店铺ID（必填）
 * @param {String} data.agent_name - 店铺名称（可选）
 * @param {String} data.contact_person - 联系人（可选）
 * @param {String} data.contact_phone - 联系电话（可选）
 * @param {String} data.contact_email - 联系邮箱（可选）
 * @param {String} data.address - 地址（可选）
 * @param {String} data.description - 描述（可选）
 */
export function updateAgent(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/update',
    method: 'post',
    data: {
      id: data.id,
      agent_name: data.agent_name,
      contact_person: data.contact_person,
      contact_phone: data.contact_phone,
      contact_email: data.contact_email,
      address: data.address,
      description: data.description
    }
  })
}

/**
 * 更新店铺状态
 * @param {Object} data - 状态数据
 * @param {Number} data.agent_id - 店铺ID（必填，实际是shop_id）
 * @param {Number} data.status - 状态（必填，0=禁用，1=启用）
 */
export function updateAgentStatus(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/update-status',
    method: 'post',
    data: {
      agent_id: data.agent_id,
      status: data.status
    }
  })
}

/**
 * 获取店铺分佣配置列表
 * @param {Object} params - 查询参数
 * @param {Number} params.agent_id - 店铺ID（必填）
 */
export function getAgentCommissions(params) {
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/commissions',
    method: 'post',
    data: {
      agent_id: params.agent_id
    }
  })
}

/**
 * 批量设置店铺分佣配置
 * @param {Object} data - 分佣配置数据
 * @param {Number} data.agent_id - 店铺ID（必填）
 * @param {Array} data.commissions - 分佣配置数组
 * @param {String} data.commissions[].package_code - 套餐编码
 * @param {Number} data.commissions[].commission_rate - 分佣比例（百分比）
 */
export function batchSetAgentCommissions(data) {
  return request({
    url: '/fuyou/iccid/recharge/admin/agents/commissions/batch-set',
    method: 'post',
    data: {
      agent_id: data.agent_id,
      commissions: data.commissions
    }
  })
}
